import { PageLayout } from '@retail/components';
import { useMemo } from 'react';
import { useParams } from 'react-router';
import { BrandCampaignDetailsContainer } from '@retail/campaign/containers';
import { useFetchBrandCampaignDetails } from '@retail/campaign/data-access';
import { BrandCampaign, BrandCampaignDTO } from '@retail/campaign/types';
import { usePermissionsForCurrentUser } from '@retail/app/stores/selected-context';

export const BrandCampaignDetailsPage = () => {
  const { campaignId } = useParams();
  const { userCanUpdate, userCanDelete } = usePermissionsForCurrentUser();
  const canEditCampaign = userCanUpdate('CAMPAIGN');
  const canDeleteCampaign = userCanDelete('CAMPAIGN');

  const { data: campaignDto } = useFetchBrandCampaignDetails({
    campaignId: campaignId ?? '',
    suspense: true,
  });
  const campaign = useMemo(() => {
    return BrandCampaign.fromDto({
      dto: campaignDto as BrandCampaignDTO,
      canEdit: canEditCampaign,
      canDelete: canDeleteCampaign,
    });
  }, [campaignDto, canDeleteCampaign, canEditCampaign]);

  return (
    <PageLayout maxWidth="full" spacing={2} fixedHeight>
      <BrandCampaignDetailsContainer campaign={campaign} />
    </PageLayout>
  );
};
